import React, { useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useFieldArray, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  AncillariAutoFormFlowStyles,
  AncillariAutoFormStyles,
} from './styles/AncillariAutoFormFlow.styles';
// import { CenteredDivTitle } from '../../common/components/CenteredPageTitle.styles';
import {
  lastfifteenYears,
} from '../../common/constants';
import {
  ancillariAutoSchema,
  answersFieldsBySteps,
} from './AncillariAutoFormFlow.validations';
import {
  getBlockingFields,
  buildMissingFieldsMessage,
  COLLAPSED_PANEL_FIELDS_BY_STEP,
} from './AncillariAutoFormFlow.stepErrors';
import {
  greeniaPrivacyPolicy,
  modifyRequestData,
} from '../../services/axios-client/axeCommons';
import {
  ancillariAutoCancelFastQuote,
  ancillariAutoChangeIndex,
  ancillariAutoGetCustomerData,
  ancillariAutoGetInitialData,
  ancillariAutoGetQuickInfo,
  ancillariAutoGetVehicleInformation,
  ancillariAutoGetVehicleModels,
  ancillariAutoGetVehicleVersions,
  ancillariAutoSubmitAnswers,
  resetAncillariAutoForm,
} from '../../features/forms/formsActions';
import generateFiscalCode, {
  safeDecodeFiscalCode,
} from '../../common/helpers/generateFiscalCode';
// import {
//   generalAlertError,
// } from '../../common/utils/alerts';
import ProgressBar from '../../common/componentsV2/ProgressBar';
import { validateCarOldPlate, validateCarPlate } from '../../common/validators';
import RcAutoFastQuoteModal from '../../common/FormFunnels/Auto/RcAutoFastQuoteModal';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import { FooterNav } from '../../common/formInputsV2/FooterNav.styles';
import { PrimaryButton, SecondaryButton } from '../../common/formInputsV2/Button.styles';
import getAllowedPolicyEffectDate from '../../common/helpers/getAllowedPolicyEffectDate';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import AncillariStepOne from './components/AncillariStepOne';
import AncillariStepThree from './components/AncillariStepThree';
import AncillariStepTwo from './components/AncillariStepTwo';
import { sonnerErrorAlert } from '../../common/utils/sonnerAlerts';
import QuoteGenerateLoading from '../../common/componentsV2/elements/QuoteGenerateLoading';

function AncillariAutoFormFlow() {
  const navigate = useNavigate();
  const location = useLocation();
  const [proceedButton, setProceedButton] = useState(true);
  const [showManualAdress, setShowManualAdress] = useState(false);
  const [showStepOneFields, setShowStepOneFields] = useState(false);
  // const [selectedVersion, setSelectedVersion] = useState(null);

  const skipCheckGenderRef = useRef(null);
  const state = useSelector((store) => store.forms.ancillari_auto);
  const {
    loading,
    isLoadingFastQuote,
    isLoadingVehicleModels,
    isLoadingVehicleVersions,
    states,
    index,
    brands,
    vehicleModels,
    vehicleVersions,
    municipalities,
    formData,
    dataPrivacy,
    fastQuoteVehicleInfo,
    loadingQuotes,
  } = state;
  const {
    register,
    formState: { errors, touchedFields },
    setValue,
    trigger,
    getValues,
    watch,
    control,
  } = useForm({
    mode: 'onTouched',
    resolver: yupResolver(ancillariAutoSchema),
    shouldFocusError: false,
    defaultValues: {
      product: 'ancillari_auto',
      source: 'greenia.it',
      policy_effective_date: '',
      privacies: [],
      name: '',
      surname: '',
      email: '',
      fiscal_code: '',
      address: '',
      house_number: '',
      postal_code: '',
      phone: '',
      gender: '',
      date_of_birth: '',
      country_of_birth_code: 'Z000',
      province_of_birth_code: null,
      commune_of_birth_code: null,
      born_abroad: false,
      residence_commune_code: '',
      residence_province_code: '',
      active_customer_id: null,
      existing_customer: false,
      business_name: '',
      vat_number: '',
      company_type: '',
      payment_frequency: 1,
      vehicle_plate: '',
      imm_vehicle_month: '',
      imm_vehicle_year: '',
      vehicle_brand_code: '',
      vehicle_model_code: '',
      vehicle_version_code: '',
      vehicle_am_code: '',
      other_power_supply: '9',
      vehicle_parking: '1',
      theft_protection_code: '4',
      vehicle_usage: '1',
      predicted_km: 10000,
      vehicle_purchased_month: '',
      vehicle_purchased_year: '',
      vehicles_owned: 2,
      tow_hook: '0',
      weight: 0,
      power: 0,
      complete_manually: false,
      is_old_plate: '0',
      vehicle_value: '',
      guarantees: [],
    },
  });

  const { fields, update, replace } = useFieldArray({
    name: 'guarantees',
    control,
  });

  // Constants
  const stepsQuote = ['Dati del Veicolo', 'Garanzie', 'Dati Personali'];

  // const title = stepsQuote[index - 1];

  const formDataFlow = watch();

  const [skipBrandCodeEffect, setSkipBrandCodeEffect] = useState(false);
  const vehicleBrandCodeEffectDependencies = useRef();
  const vehicleBrandCodeDeps = [
    formDataFlow.vehicle_brand_code,
    formDataFlow.imm_vehicle_year,
  ];

  useEffect(() => {
    if (skipBrandCodeEffect) {
      setSkipBrandCodeEffect(false);
      return;
    }

    if (vehicleBrandCodeEffectDependencies.current === undefined) {
      vehicleBrandCodeEffectDependencies.current = JSON.stringify(vehicleBrandCodeDeps);
      return;
    }

    if (
      vehicleBrandCodeEffectDependencies.current
      === JSON.stringify(vehicleBrandCodeDeps)
    ) {
      return;
    }

    vehicleBrandCodeEffectDependencies.current = JSON.stringify(vehicleBrandCodeDeps);
    setValue('vehicle_model_code', '');
  }, vehicleBrandCodeDeps);

  const [skipModelCodeEffect, setSkipModelCodeEffect] = useState(false);
  const vehicleModelCodeEffectDependencies = useRef();
  const vehicleModelCodeDeps = [formDataFlow.vehicle_model_code];
  useEffect(() => {
    if (skipModelCodeEffect) {
      setSkipModelCodeEffect(false);
      return;
    }

    if (vehicleModelCodeEffectDependencies.current === undefined) {
      vehicleModelCodeEffectDependencies.current = JSON.stringify(vehicleModelCodeDeps);
      return;
    }

    if (
      vehicleModelCodeEffectDependencies.current
      === JSON.stringify(vehicleModelCodeDeps)
    ) {
      return;
    }

    vehicleModelCodeEffectDependencies.current = JSON.stringify(vehicleModelCodeDeps);

    setValue('vehicle_version_code', null);
    setValue('vehicle_am_code', '');
  }, vehicleModelCodeDeps);

  const updateFormData = (data) => {
    const keys = Object.keys(data);
    keys.forEach((key) => {
      setValue(key, data[key], {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    });
    trigger(keys);
  };

  const updateUserData = (data) => {
    const keys = Object.keys(data);
    keys.forEach((key) => {
      setValue(key, data[key], {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    });
    trigger(keys);
  };

  const isValid = (name) => {
    if (errors[name]?.message !== undefined) {
      return false;
    }

    if (touchedFields[name] === undefined) {
      return false;
    }

    return true;
  };

  const privacyItemChangeHandler = (value, item) => {
    if (!value.target.checked) {
      const newArray = [...formDataFlow.privacies];
      const index = newArray.indexOf(item.id);
      newArray.splice(index, 1);
      updateFormData({
        privacies: newArray,
      });
      return;
    }
    const answersNewArray = [...formDataFlow.privacies];
    answersNewArray.push(item.id);
    updateFormData({
      privacies: answersNewArray,
    });
  };

  const getCustomerData = async (customerId) => {
    ancillariAutoGetCustomerData(customerId);
  };

  const getQuickInfo = () => {
    ancillariAutoGetQuickInfo(formDataFlow.vehicle_plate, updateFormData);
  };

  const scrollToFirstError = () => {
    setTimeout(() => {
      const el = document.querySelector('.is-invalid, [aria-invalid="true"], .general-input-error, .invalid-feedback.d-block');
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 300);
  };

  const procceedWithFastQuote = async () => {
    const checkPlate = (vehicle_plate) => (formDataFlow.is_old_plate === '0' ? validateCarPlate(vehicle_plate) : validateCarOldPlate(vehicle_plate));

    if (location.state !== null) {
      return;
    }

    // No / invalid plate: surface the field error instead of silently ignoring the click.
    if (!checkPlate(formDataFlow.vehicle_plate)) {
      await trigger(['vehicle_plate', 'is_old_plate']);
      sonnerErrorAlert('Inserisci una targa valida per continuare.');
      scrollToFirstError();
      return;
    }

    ancillariAutoGetVehicleInformation(
      formDataFlow.vehicle_plate,
      getQuickInfo,
      formDataFlow.is_old_plate,
    );
    setProceedButton(false);
  };

  useEffect(() => {
    ancillariAutoGetInitialData();

    return () => {
      resetAncillariAutoForm();
    };
  }, []);

  useEffect(() => {
    if (
      location.state !== null
      && location.state.activeCustomerId !== undefined
    ) {
      getCustomerData(location.state.activeCustomerId);
    }
  }, []);

  const getFiscalCode = (birthDate) => {
    const d = birthDate.split('-');
    const fData = {
      name: formDataFlow.name,
      surname: formDataFlow.surname,
      gender: formDataFlow.gender,
      day: d[2],
      month: d[1],
      year: d[0],
    };
    if (formDataFlow.born_abroad) {
      fData.birthplace = states.filter(
        (s) => s.state_code === formDataFlow.country_of_birth_code,
      )[0].name;
      fData.birthplaceProvincia = 'EE';
    } else {
      fData.birthplace = municipalities.filter(
        (municipality) => municipality.cadastral_code === formDataFlow.commune_of_birth_code,
      )[0].name;
      fData.birthplaceProvincia = formDataFlow.province_of_birth_code;
    }
    return generateFiscalCode(fData);
  };

  const [showPrivacyErrors, setShowPrivacyErrors] = useState(false);

  const validateDataPrivacy = () => {
    let { error, message } = '';

    dataPrivacy.forEach((privacy) => {
      if (privacy.required === 1) {
        const userDataArray = { ...formDataFlow }; // make a separate copy of the object
        const index = userDataArray.privacies.indexOf(privacy.id);

        if (index < 0) {
          error = true;
          message = 'Tutti i campi sono obbligatori! Tutta la privacy con la stella deve essere controllata';
        }
      }
    });
    return { error, message };
  };

  const submitForm = () => {
    const { error, message } = validateDataPrivacy();

    if (error) {
      setShowPrivacyErrors(true);
      sonnerErrorAlert(message);
      scrollToFirstError();
      return;
    }

    const _userData = { ...formDataFlow };

    if (_userData.born_abroad && _userData.country_of_birth_code === 'Z000') {
      window.scrollTo(0, 0);
      sonnerErrorAlert('Non puoi selezionare Italia come stato estero!');
      return;
    }

    if (
      _userData.born_abroad
      && (_userData.country_of_birth_code === null
        || _userData.country_of_birth_code === ''
        || _userData.country_of_birth_code == undefined)
    ) {
      window.scrollTo(0, 0);
      sonnerErrorAlert('Devi selezionare uno stato estero!');
      return;
    }

    if (
      formDataFlow.date_of_birth !== ''
      && formDataFlow.date_of_birth !== null
    ) {
      _userData.date_of_birth = moment(formDataFlow.date_of_birth).format(
        'YYYY-MM-DD',
      );
    } else {
      _userData.date_of_birth = null;
    }
    _userData.policy_effective_date = moment(
      formDataFlow.policy_effective_date,
    ).format('YYYY-MM-DD');
    _userData.fiscal_code = formDataFlow.gender !== 'G'
      ? getFiscalCode(formDataFlow.date_of_birth)
      : null;
    delete _userData.existing_customer;
    delete _userData.complete_manually;
    delete _userData.persona_giuridica;
    ancillariAutoSubmitAnswers(_userData, navigate);
  };

  // useEffect(() => {
  //   if (formDataFlow.vehicle_am_code !== '') {
  //     const version = vehicleVersions.find((v) => v.AM_code === formDataFlow.vehicle_am_code);

  //     if (version !== undefined) {
  //       setSelectedVersion(version);
  //     }
  //   }
  // }, [formDataFlow.vehicle_am_code, vehicleVersions]);

  const prevButton = () => {
    if (index > 1) {
      ancillariAutoChangeIndex(index - 1);
    }
  };

  const nextButton = async () => {
    const res = await trigger(answersFieldsBySteps[index - 1]);

    if (res !== true) {
      const stepFields = answersFieldsBySteps[index - 1];
      const blocking = getBlockingFields(errors, stepFields);

      // Step 2 is just the guarantees list — point straight at it.
      if (index === 2 && errors.guarantees) {
        window.scrollTo(0, 0);
        sonnerErrorAlert('Seleziona almeno una garanzia per continuare.');
        return;
      }

      // Auto-open the collapsed "Detagli" panel when a blocking field lives inside it.
      const panelFields = COLLAPSED_PANEL_FIELDS_BY_STEP[index] || [];
      if (index === 1 && blocking.some((field) => panelFields.includes(field))) {
        setShowStepOneFields(true);
      }

      sonnerErrorAlert(buildMissingFieldsMessage(blocking));
      scrollToFirstError();
      return;
    }

    if (index === 1) {
      const version = vehicleVersions.find((v) => v.AM_code === formDataFlow.vehicle_am_code);
      if (version) {
        // const currYear = new Date().getFullYear();
        // const versionYear = version.year;
        // const isMoreThan6YearsOld = currYear - versionYear > 6;
        // if (isMoreThan6YearsOld) {
        //   generalAlertError('Attenzione. I veicoli con età maggiore di 6 anni sono soggetti a riserva direzionale. Contatta il back office per completare quotazione!');
        //   return;
        // }
        // ? TBD Whaat to do here
      }
    }

    if (index === 3) {
      if (
        formDataFlow.born_abroad
        && formDataFlow.country_of_birth_code === 'Z000'
      ) {
        window.scrollTo(0, 0);
        sonnerErrorAlert('Non puoi selezionare Italia come stato estero!');
        return;
      }

      if (
        formDataFlow.born_abroad
        && (formDataFlow.country_of_birth_code === null
          || formDataFlow.country_of_birth_code === ''
          || formDataFlow.country_of_birth_code == undefined)
      ) {
        window.scrollTo(0, 0);
        sonnerErrorAlert('Devi selezionare uno stato estero!');
        return;
      }
    }

    if (index === 3) {
      const validation = validateDataPrivacy();
      if (validation.error) {
        setShowPrivacyErrors(true);
        sonnerErrorAlert(validation.message);
        scrollToFirstError();
        return;
      }
    }

    if (index === 3) {
      submitForm();
      return;
    }

    ancillariAutoChangeIndex(index + 1);
    setTimeout(() => window.scrollTo(0, 0), 500);
  };

  const cancelFastquote = () => {
    ancillariAutoCancelFastQuote();
    setProceedButton(true);
  };

  const confirmFastQuote = () => {
    if (fastQuoteVehicleInfo.frontend.persona_giuridica === true) {
      const commune_of_birth_code = null;
      const province_of_birth_code = null;
      const born_abroad = false;
      const country_of_birth_code = null;

      setSkipBrandCodeEffect(true);
      setSkipModelCodeEffect(true);
      skipCheckGenderRef.current = true;
      const isAllowedYear = lastfifteenYears.find(
        (y) => y.id == fastQuoteVehicleInfo.frontend.imm_vehicle_year,
      );
      updateFormData(
        {
          vehicle_am_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_am_code,
          business_name: fastQuoteVehicleInfo.frontend.business_name,
          fiscal_code: fastQuoteVehicleInfo.frontend.fiscal_code,
          imm_vehicle_month: fastQuoteVehicleInfo.frontend.imm_vehicle_month,
          imm_vehicle_year:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.imm_vehicle_year,
          name: fastQuoteVehicleInfo.frontend.name,
          postal_code: fastQuoteVehicleInfo.frontend.postal_code,
          power:
            isAllowedYear === undefined
              ? formDataFlow.power
              : fastQuoteVehicleInfo.frontend.power,
          surname: fastQuoteVehicleInfo.frontend.surname,
          vat_number: fastQuoteVehicleInfo.frontend.vat_number,
          vehicle_brand_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_brand_code,
          vehicle_model_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_model_code,
          vehicle_version_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_version_code,
          weight:
            isAllowedYear === undefined
              ? formDataFlow.weight
              : fastQuoteVehicleInfo.frontend.weight,
          policy_effective_date:
            getAllowedPolicyEffectDate('min')
              <= fastQuoteVehicleInfo.frontend.policy_effective_date
              && fastQuoteVehicleInfo.frontend.policy_effective_date
              <= getAllowedPolicyEffectDate('max')
              ? fastQuoteVehicleInfo.frontend.policy_effective_date
              : '',
          date_of_birth: null,
          commune_of_birth_code,
          province_of_birth_code,
          born_abroad,
          country_of_birth_code,
          gender: 'G',
        },
        true,
      );
    } else {
      const fiscalObj = safeDecodeFiscalCode(
        fastQuoteVehicleInfo.frontend.fiscal_code,
      );

      const isAllowedYear = lastfifteenYears.find(
        (y) => y.id == fastQuoteVehicleInfo.frontend.imm_vehicle_year,
      );

      let commune_of_birth_code = null;
      let province_of_birth_code = null;
      let born_abroad = false;
      let country_of_birth_code = 'Z000';
      let gender = '';
      let date_of_birth = null;

      if (fiscalObj) {
        const commune = municipalities.find(
          (municipality) => municipality.name.toLowerCase() === fiscalObj.birthplace.toLowerCase(),
        );

        if (fiscalObj.birthplaceProvincia !== 'EE') {
          if (commune) {
            commune_of_birth_code = commune.cadastral_code;
            province_of_birth_code = fiscalObj.birthplaceProvincia;
          }
        } else {
          born_abroad = true;
          let state = null;
          if (fiscalObj.birthplace === 'MACEDONIA DEL NORD') {
            state = states.find((s) => s.name === 'MACEDONIA');
          } else {
            state = states.find((s) => s.name === fiscalObj.birthplace);
          }

          if (state !== undefined) {
            country_of_birth_code = state.state_code;
          }
        }

        gender = fiscalObj.gender;
        date_of_birth = `${fiscalObj.year}-${fiscalObj.month < 10 ? `0${fiscalObj.month}` : fiscalObj.month
        }-${fiscalObj.day < 10 ? `0${fiscalObj.day}` : fiscalObj.day}`;
      }

      setSkipBrandCodeEffect(true);
      setSkipModelCodeEffect(true);
      skipCheckGenderRef.current = true;
      updateFormData(
        {
          vehicle_am_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_am_code,
          business_name: fastQuoteVehicleInfo.frontend.business_name,
          fiscal_code: fiscalObj ? fastQuoteVehicleInfo.frontend.fiscal_code : '',
          imm_vehicle_month: fastQuoteVehicleInfo.frontend.imm_vehicle_month,
          imm_vehicle_year:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.imm_vehicle_year,
          // Without a valid fiscal code the gender change effect would reset them anyway
          name: fiscalObj ? fastQuoteVehicleInfo.frontend.name : '',
          postal_code: fastQuoteVehicleInfo.frontend.postal_code,
          power:
            isAllowedYear === undefined
              ? formDataFlow.power
              : fastQuoteVehicleInfo.frontend.power,
          surname: fiscalObj ? fastQuoteVehicleInfo.frontend.surname : '',
          vat_number: fastQuoteVehicleInfo.frontend.vat_number,
          vehicle_brand_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_brand_code,
          vehicle_model_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_model_code,
          vehicle_version_code:
            isAllowedYear === undefined
              ? ''
              : fastQuoteVehicleInfo.frontend.vehicle_version_code,
          weight:
            isAllowedYear === undefined
              ? formDataFlow.weight
              : fastQuoteVehicleInfo.frontend.weight,
          policy_effective_date:
            getAllowedPolicyEffectDate('min')
              <= fastQuoteVehicleInfo.frontend.policy_effective_date
              && fastQuoteVehicleInfo.frontend.policy_effective_date
              <= getAllowedPolicyEffectDate('max')
              ? fastQuoteVehicleInfo.frontend.policy_effective_date
              : '',
          date_of_birth,
          commune_of_birth_code,
          province_of_birth_code,
          born_abroad,
          country_of_birth_code,
          gender,
        },
        true,
      );
    }

    ancillariAutoCancelFastQuote();
  };

  useEffect(() => {
    const triggerPlateValidation = async () => {
      await trigger('vehicle_plate', {
        shouldTouch: true,
        shouldDirty: true,
        shouldValidate: true,
      });
    };

    if (formDataFlow.vehicle_plate !== '') {
      triggerPlateValidation();
    }
  }, [formDataFlow.is_old_plate]);

  useEffect(() => {
    if (formDataFlow.vehicle_brand_code) {
      ancillariAutoGetVehicleModels(
        formDataFlow.vehicle_brand_code,
        formDataFlow.imm_vehicle_year,
      );
    }
  }, [formDataFlow.vehicle_brand_code, formDataFlow.imm_vehicle_year]);

  useEffect(() => {
    if (
      formDataFlow.vehicle_brand_code
      && formDataFlow.vehicle_model_code
      && formDataFlow.imm_vehicle_year
    ) {
      ancillariAutoGetVehicleVersions(
        formDataFlow.vehicle_model_code,
        formDataFlow.imm_vehicle_year,
      );
    }
  }, [
    formDataFlow.vehicle_brand_code,
    formDataFlow.vehicle_model_code,
    formDataFlow.imm_vehicle_year,
  ]);

  useEffect(() => {
    if (skipCheckGenderRef.current === true) {
      skipCheckGenderRef.current = false;
      return;
    }

    const triggerValidation = {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    };

    if (formDataFlow.gender === 'G') {
      setValue('date_of_birth', null);
      setValue('country_of_birth_code', null);
      setValue('province_of_birth_code', null);
      setValue('commune_of_birth_code', null);
      setValue('born_abroad', false);
      setValue('name', null);
      setValue('surname', null);
    } else if (
      ['M', 'F'].includes(formDataFlow.gender)
      && formDataFlow.date_of_birth === null
    ) {
      setValue('date_of_birth', '', triggerValidation);
      setValue('country_of_birth_code', 'Z000', triggerValidation);
      setValue('province_of_birth_code', null, triggerValidation);
      setValue('commune_of_birth_code', null, triggerValidation);
      setValue('born_abroad', false, triggerValidation);
      setValue('name', '', triggerValidation);
      setValue('surname', '', triggerValidation);
    }
  }, [formDataFlow.gender, formDataFlow.date_of_birth]);

  // On entering a step, mark that step's prefilled fields touched and validate
  // only them — so defaults show green borders without firing errors for
  // fields the user has not reached yet. Array fields (guarantees) are skipped:
  // the field array manages its own touched state.
  useEffect(() => {
    const values = getValues();
    if (values === undefined) {
      return;
    }

    const stepFields = answersFieldsBySteps[index - 1] || [];
    const filledKeys = stepFields.filter(
      (key) => values[key] !== ''
        && values[key] !== null
        && values[key] !== undefined
        && !Array.isArray(values[key]),
    );
    if (filledKeys.length === 0) {
      return;
    }
    filledKeys.forEach((key) => {
      setValue(key, values[key], { shouldTouch: true, shouldDirty: true });
    });
    trigger(filledKeys);
  }, [index]);

  // Keep step 1's collapsed "Detagli" panel open whenever any field inside it
  // is in an error state, so errors surfaced by "Continua" are never hidden.
  useEffect(() => {
    const panelFields = COLLAPSED_PANEL_FIELDS_BY_STEP[index] || [];
    if (!panelFields.some((field) => errors[field])) {
      return;
    }
    if (index === 1) setShowStepOneFields(true);
  }, [errors, index]);

  useEffect(() => {
    const callAsync = async () => {
      if (
        location.state !== null
        && location.state.requestToken !== undefined
      ) {
        skipCheckGenderRef.current = true;
        const {
          data: {
            data: { userData },
          },
        } = await modifyRequestData(location.state.requestToken);

        setSkipBrandCodeEffect(true);
        setSkipModelCodeEffect(true);

        // Handle guarantees separately with field array replace
        if (userData.guarantees && Array.isArray(userData.guarantees)) {
          // Transform guarantees to ensure parameterValues is always an object
          const transformedGuarantees = userData.guarantees.map((guarantee) => ({
            ...guarantee,
            parameterValues: Array.isArray(guarantee.parameterValues)
              ? {}
              : (guarantee.parameterValues || {}),
          }));
          replace(transformedGuarantees);
          const { guarantees, ...restUserData } = userData;
          updateFormData(restUserData);
        } else {
          updateFormData(userData);
        }
      }
    };

    callAsync();
  }, [location]);

  useEffect(() => {
    if (formDataFlow.imm_vehicle_year !== '') {
      setProceedButton(false);
    }
  }, [formDataFlow.imm_vehicle_year]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <PageLoading />;
  }

  if (loadingQuotes) {
    return <QuoteGenerateLoading countNr={45} />;
  }

  return (
    <AncillariAutoFormFlowStyles>
      <V2FontImport />
      {fastQuoteVehicleInfo !== null && (
        <RcAutoFastQuoteModal
          cancelFastquote={cancelFastquote}
          confirmFastQuote={confirmFastQuote}
          answers={formDataFlow}
          fastQuoteVehicleInfo={fastQuoteVehicleInfo}
        />
      )}

      <div className="d-flex align-content-center justify-content-center">
        <ProgressBar activeStep={index} steps={stepsQuote} />
      </div>
      <AncillariAutoFormStyles>
        {/* Title removed — the v2 ProgressBar already shows the step name
          (steps list on desktop/tablet, "Passo X di N · label" on mobile).
        <CenteredDivTitle className="d-flex align-items-center justify-content-center gap-3 mt-3">
          <div className="row title-questionnaire">
            <div className="quote-h2 divider">
              <h2>{title}</h2>
            </div>
          </div>
        </CenteredDivTitle> */}

        {index === 1 && (
          <AncillariStepOne
            formDataFlow={formDataFlow}
            updateFormData={updateFormData}
            register={register}
            errors={errors}
            isValid={isValid}
            vehicleVersions={vehicleVersions}
            isLoadingFastQuote={isLoadingFastQuote}
            brands={brands}
            isLoadingVehicleModels={isLoadingVehicleModels}
            isLoadingVehicleVersions={isLoadingVehicleVersions}
            vehicleModels={vehicleModels}
            formData={formData}
            showStepOneFields={showStepOneFields}
            setShowStepOneFields={setShowStepOneFields}
          />
        )}
        {index === 2 && (
          <AncillariStepTwo
            fields={fields}
            replace={replace}
            update={update}
          />
        )}
        {index === 3 && (
          <AncillariStepThree
            register={register}
            errors={errors}
            isValid={isValid}
            formDataFlow={formDataFlow}
            updateUserData={updateUserData}
            states={states}
            municipalities={municipalities}
            formData={formData}
            updateFormData={updateFormData}
            showManualAdress={showManualAdress}
            setShowManualAdress={setShowManualAdress}
            dataPrivacy={dataPrivacy}
            privacyItemChangeHandler={privacyItemChangeHandler}
            greeniaPrivacyPolicy={greeniaPrivacyPolicy}
            showPrivacyErrors={showPrivacyErrors}
          />
        )}

        {index == 1 && proceedButton === true && (
          <div className="d-flex justify-content-center align-items-center mt-5">
            <PrimaryButton
              type="button"
              className="btn btn-questionnaire"
              onClick={() => procceedWithFastQuote()}
            >
              Procedi
            </PrimaryButton>
          </div>
        )}

        {index >= 1 && index <= 4 && (
          <FooterNav className="footer-buttons">
            <div className="d-flex justify-content-between">
              {index !== 1 && (
                <SecondaryButton
                  type="button"
                  className="btn btn-questionnaire back backtoStepOne backtoStepTwo backtoStepThree"
                  onClick={prevButton}
                >
                  Indietro
                </SecondaryButton>
              )}

              {proceedButton === false && (
                <PrimaryButton
                  type="button"
                  className="btn btn-questionnaire continueStepThree continueStepFour buttonFinal"
                  onClick={nextButton}
                  id="continueStep2"
                >
                  {index === 3 ? 'Vai ai preventivi' : 'Continua'}
                </PrimaryButton>
              )}
            </div>
          </FooterNav>
        )}
      </AncillariAutoFormStyles>
    </AncillariAutoFormFlowStyles>
  );
}

export default AncillariAutoFormFlow;
